import React from 'react'
import AppTable from '../../../../../../common/AppTable/AppTable'
import RenderHtml from '../../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml'
import { sortNewPartsTableData, sortPartsTableData } from '../../../../../Documents/components/Tables/sortPartsTableData'
import './ItemsRequiredTable.css'

/**
 * Step BOM rows from snapshots/API may be nested under part_info (same as Documents PartsTable step format).
 * Using only flat row.type / row.partNumber leaves cells empty while qty at root still shows.
 */
function pickDisplayCells (row) {
  if (!row || typeof row !== 'object') {
    return { type: '', partNumber: '', description: '', qty: '', unit_name: '' }
  }
  const pi = row.part_info
  if (pi && typeof pi === 'object') {
    return {
      type:
        pi.type_info?.name ??
        pi.type_info?.type_name ??
        pi.type_details?.name ??
        pi.type_name ??
        pi.type ??
        row.type ??
        '',
      partNumber: pi.part_number ?? row.partNumber ?? '',
      description: pi.description ?? row.description ?? '',
      table_note:pi.table_note,
      qty: row.qty,
      unit_name: pi.unit_info?.unit_name ?? row.unit_name ?? '',
    }
  }
  return {
    type: row.type ?? '',
    partNumber: row.partNumber ?? '',
    description: row.description ?? '',
    qty: row.qty,
    unit_name: row.unit_name ?? '',
    table_note:row.table_note
  }
}

const ItemsRequiredTable = ({ tableTitle, columnTitle, parts_required }) => {
  const columnsData = [
    { headName: 'Type', field: 'type' },
    { headName: columnTitle, field: 'item_code' },
    { headName: 'Description', field: 'description' },
    { headName: 'Qty. Per', field: 'qty' },
    { headName: 'Unit', field: 'unit' },
  ]

  const raw = Array.isArray(parts_required) ? parts_required : []
  const useNestedStepShape = raw.some((r) => r && typeof r === 'object' && r.part_info)
  const data = useNestedStepShape
    ? sortPartsTableData(raw, 'step')
    : sortNewPartsTableData(raw)

  return (
    <div className="audit-items-required-table">
      <h4 style={{ marginBottom: '8px' }}>{tableTitle}</h4>

      <AppTable
        columnsData={columnsData}
        showSearchInput={false}
        paginate={false}
        extrapadding="0px"
        hideScrollbar={true}
      >
        {data.map((row, idx) => {
          const d = pickDisplayCells(row)
          return (
            <tr key={idx}>
              <td>{d.type}</td>
              <td>{d.partNumber}</td>
              <td>
                <RenderHtml content={d.description} />
                <>
                  <div><RenderHtml content={d?.table_note} /></div>
                </>
              </td>
              <td>{d.qty === 0 || d.qty === undefined || d.qty === null ? '' : d.qty}</td>
              <td>{d.unit_name}</td>
            </tr>
          )
        })}
      </AppTable>
    </div>
  )
}

export default ItemsRequiredTable
